import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import Swal from "sweetalert2";

import { Link } from "react-router-dom";
import { stateCity } from "../../common/cityData";

const TeacherRegistration = () => {
  // Step 1: Define State
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    teacher_gender: "",
    medium: "",
    examination: "",
    course: "",
    state: "",
    city: "",
    address: "",
  });

  // Step 2: Handle Input Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Step 3: Handle Form Submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Convert to URL-encoded format
    const urlEncodedData = new URLSearchParams(formData).toString();

    try {
      const response = await fetch(
        "https://topfaculty.co.in/api/teacher_registration.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: urlEncodedData,
        }
      );

      const result = await response.json();
      console.log("Result:", result);

      // Step 4: Handle API Response
      if (result.status === 201) {
        // alert("Student registered successfully!");
        Swal.fire({
          title: "Teacher registered successfully!",
          text: "Please login after Complete Your Profile.",
          icon: "success",
          confirmButtonText: "Ok",
        });

        setFormData({
          name: "",
          email: "",
          phone: "",
          password: "",
          teacher_gender: "",
          medium: "",
          examination: "",
          course: "",
          state: "",
          city: "",
          address: "",
        });
      } else {
        alert(result.message || "Registration failed.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    // jQuery-style logic
    const stateDropdown = document.getElementById("inputState");
    const cityDropdown = document.getElementById("inputDistrict");

    stateDropdown.addEventListener("change", function () {
      const selectedState = this.value;
      const cities = stateCity[selectedState] || [];

      // Clear previous cities
      cityDropdown.innerHTML = '<option value="">-- select one --</option>';

      // Append new city options
      cities.forEach((city) => {
        const option = document.createElement("option");
        option.value = city;
        option.textContent = city;
        cityDropdown.appendChild(option);
      });
    });
  }, []);

  return (
    <>
      <div id="rs-latest-news" className="rs-courses-details">

          <img
          src="assetsfront/images/techregistration.jpg"
          alt="student registration"
          style={{
            marginTop: "0%",
            width: "100%",
            // height: "200px",
            objectFit: "cover",
          }}
        />

        <div className="container">
            <h1
            className="title text-center  mt-4 "
            style={{ fontWeight: "600" }}
          >
            Teacher <strong style={{ color: "#f7b205" }}> Registration</strong>
          </h1>
          <div className="row">
            {/* <div className="col-md-1"></div> */}

            <div className="col-md-12">
              <div className="#">
                <div className="container h-100">
                  <div className="row h-100 justify-content-center align-items-center">
                    <form
                      className="col-md-12"
                      method="post"
                      onSubmit={handleSubmit}
                      enctype="multipart/form-data"
                    >
                      <div className="AppForm shadow-lg" style={{borderRight: "6px solid #f7b205", borderRadius: "12px"}}>
                        <div className="row">
                          <div className="col-md-3">
                            <div
                              className="AppFormRight position-relative d-flex justify-content-center flex-column align-items-center text-center p-3 text-white"
                              style={{
                                backgroundImage:
                                  "url('assetsfront/images/tectbann.avif')",
                              }}
                            >
                              <img
                                src="assetsfront/images/teach.png"
                                style={{
                                  border: "3px solid white",
                                  borderRadius: "205px",
                                  padding: "1px",
                                }}
                              ></img>
                              <h2
                                className="position-relative px-4 pb-3 mb-2"
                                style={{
                                  fontSize: "26px",
                                  color: "white",
                                  fontWeight: "700",
                                }}
                              >
                                Welcome
                              </h2>
                              <p>
                                " टॉप फैकल्टी शिक्षकों के लिए एक बेहतरीन
                                प्लेटफॉर्म है, जहां वे पूरे भारत के छात्रों तक
                                अपनी विशेषज्ञता पहुंचा सकते हैं। एक ट्यूटर के
                                रूप में, आप पूरा कोर्स या कोई विशेष विषय घर बैठे
                                पढ़ा सकते हैं। हम आपको एक आसान और प्रभावी ऑनलाइन
                                शिक्षण अनुभव प्रदान करते हैं। "
                              </p>
                            </div>
                          </div>

                          <div className="col-md-9  p-4 align-items-center ">
                            <div className="AppFormLeft">
                              <h1>Registration</h1>
                              <div className="row">
                                <div className="col-lg-4 form-group position-relative mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="username"
                                    placeholder="Username"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                  />
                                  <i className="fa fa-user-o" />
                                </div>
                                <div className="col-lg-4  form-group position-relative mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="username"
                                    placeholder="Email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                  />
                                  <i className="fa fa-envelope" />
                                </div>

                                <div className="col-lg-4  form-group position-relative mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="username"
                                    placeholder="Phone"
                                    name="phone"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                  />
                                  <i className="fa fa-phone" />
                                </div>

                                <div className="col-lg-4  form-group position-relative mb-4">
                                  <input
                                    type="password"
                                    className="form-control"
                                    id="password"
                                    placeholder="Password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                  />
                                  <i className="fa fa-key" />
                                </div>
                                <div className="col-lg-4 form-group position-relative mb-4">
                                  <select
                                    className="form-control"
                                    id="Medium"
                                    name="teacher_gender"
                                    value={formData.teacher_gender}
                                    onChange={handleChange}
                                  >
                                    <option value="">Select Gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                  </select>
                                  <i className="fa fa-user-o" />
                                </div>
                                {/* <div className="col-lg-4 form-group position-relative mb-4">
                                  <input
                                    type="file"
                                    className="form-control border-top-0 border-right-0 border-left-0 rounded-0 shadow-none"
                                    id="username"
                                    placeholder="Profile Image"
                                    name="tech_profile"
                                    value={formData.tech_profile}
                                    onChange={handleChange}
                                  />
                                  <i className="fa fa-picture-o" />
                                </div> */}
                                <div className="col-lg-4 form-group position-relative mb-4">
                                  <select
                                    className="form-control"
                                    id="Medium"
                                    name="medium"
                                    value={formData.medium}
                                    onChange={handleChange}
                                  >
                                    <option value="">Select Medium</option>
                                    <option value="hindi">Hindi</option>
                                    <option value="english">English</option>
                                  </select>
                                </div>

                                <div className="col-lg-4  form-group position-relative mb-4">
                                  <input
                                    type="text"
                                    className="form-control "
                                    id="username"
                                    placeholder="Examination"
                                    name="examination"
                                    value={formData.examination}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>
                                <div className="col-lg-4  form-group position-relative mb-4">
                                  <input
                                    type="text"
                                    className="form-control "
                                    id="username"
                                    placeholder="Course"
                                    name="course"
                                    value={formData.course}
                                    onChange={handleChange}
                                    required
                                  />
                                </div>

                                <div className="col-lg-4  form-group position-relative mb-4">
                                  <select
                                    class="form-control"
                                    id="inputState"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                  >
                                    <option value="SelectState">
                                      Select State
                                    </option>
                                    <option value="Andra Pradesh">
                                      Andra Pradesh
                                    </option>
                                    <option value="Arunachal Pradesh">
                                      Arunachal Pradesh
                                    </option>
                                    <option value="Assam">Assam</option>
                                    <option value="Bihar">Bihar</option>
                                    <option value="Chhattisgarh">
                                      Chhattisgarh
                                    </option>
                                    <option value="Goa">Goa</option>
                                    <option value="Gujarat">Gujarat</option>
                                    <option value="Haryana">Haryana</option>
                                    <option value="Himachal Pradesh">
                                      Himachal Pradesh
                                    </option>
                                    <option value="Jammu and Kashmir">
                                      Jammu and Kashmir
                                    </option>
                                    <option value="Jharkhand">Jharkhand</option>
                                    <option value="Karnataka">Karnataka</option>
                                    <option value="Kerala">Kerala</option>
                                    <option value="Madya Pradesh">
                                      Madya Pradesh
                                    </option>
                                    <option value="Maharashtra">
                                      Maharashtra
                                    </option>
                                    <option value="Manipur">Manipur</option>
                                    <option value="Meghalaya">Meghalaya</option>
                                    <option value="Mizoram">Mizoram</option>
                                    <option value="Nagaland">Nagaland</option>
                                    <option value="Odisha">Odisha</option>
                                    <option value="Punjab">Punjab</option>
                                    <option value="Rajasthan">Rajasthan</option>
                                    <option value="Sikkim">Sikkim</option>
                                    <option value="Tamil Nadu">
                                      Tamil Nadu
                                    </option>
                                    <option value="Telangana">Telangana</option>
                                    <option value="Tripura">Tripura</option>
                                    <option value="Uttaranchal">
                                      Uttaranchal
                                    </option>
                                    <option value="Uttar Pradesh">
                                      Uttar Pradesh
                                    </option>
                                    <option value="West Bengal">
                                      West Bengal
                                    </option>
                                    <option
                                      disabled
                                      style={{
                                        backgroundColor: "#aaa",
                                        color: "#fff",
                                      }}
                                    >
                                      UNION Territories
                                    </option>
                                    <option value="Andaman and Nicobar Islands">
                                      Andaman and Nicobar Islands
                                    </option>
                                    <option value="Chandigarh">
                                      Chandigarh
                                    </option>
                                    <option value="Dadar and Nagar Haveli">
                                      Dadar and Nagar Haveli
                                    </option>
                                    <option value="Daman and Diu">
                                      Daman and Diu
                                    </option>
                                    <option value="Delhi">Delhi</option>
                                    <option value="Lakshadeep">
                                      Lakshadeep
                                    </option>
                                    <option value="Pondicherry">
                                      Pondicherry
                                    </option>
                                  </select>
                                  <i className="fa fa-map-marker" />
                                </div>
                                <div className="col-lg-4  form-group position-relative mb-4">
                                  <select
                                    class="form-control"
                                    name="city"
                                    value={formData.city}
                                    onChange={handleChange}
                                    id="inputDistrict"
                                  >
                                    <option value="">-- select one -- </option>
                                  </select>
                                  <i className="fa fa-map-marker" />
                                </div>
                                <div className="col-lg-8  form-group position-relative mb-4">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="username"
                                    placeholder="Address"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                  />
                                  <i className="fa fa-map-marker" />
                                </div>
                              </div>
                              <button
                                type="submit"
                                className="btn btn-success btn-block shadow border-0 py-2 text-uppercase"
                              >
                                Teacher Registration
                              </button>
                              <p className=" mt-5">
                                Do have Already an account?
                                <Link
                                target="_blank"
                                 to={"https://topfaculty.co.in/c_pannel"}>
                                  <span>Login Here</span>
                                </Link>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-md-1"></div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherRegistration;
